// Impression de l'iframe d'aperçu — c'est ce qui produit le PDF.
//
// LE POINT DÉLICAT. Nous ne générons pas le PDF : `contentWindow.print()` ouvre
// la boîte de dialogue du navigateur, et c'est CHROME qui propose le nom du
// fichier, dérivé du `<title>` du document imprimé. Reste à savoir de quel
// document : celui de la FRAME, ou celui de la PAGE HÔTE ?
//
// La réponse dépend du contexte (`srcdoc` n'a pas d'URL propre), et elle n'est
// pas observable depuis nos tests : ni Playwright ni le CDP n'exposent le nom
// proposé dans la boîte de dialogue native. Plutôt que de parier, on pose le
// MÊME titre des deux côtés — la frame le porte déjà (il est écrit dans le HTML
// rendu par `resumeHtml` / `coverLetterHtml`), on aligne l'hôte le temps de
// l'impression. Quel que soit celui que Chrome retienne, il tombe sur la même
// chaîne, et le jour où ce comportement change, rien ne casse.
//
// Le titre n'est PAS un paramètre de cette fonction, à dessein : il est lu sur
// le document de la frame. Une seconde source pourrait diverger de celle qui
// nomme le DOCX, et c'est exactement la divergence qu'on est en train de
// supprimer (cf. `documentName.ts` dans le moteur).

/**
 * Imprime le document d'une iframe en garantissant le nom de fichier proposé.
 *
 * Le titre de la page hôte est restauré dans un `finally` : `window.print()`
 * bloque le thread jusqu'à la fermeture de la boîte de dialogue, donc l'onglet
 * reprend son nom dès que l'utilisateur a enregistré ou annulé. Sans cette
 * restauration, l'extension laisserait l'onglet LinkedIn renommé.
 */
export function printFrame(win: Window | null | undefined): void {
  if (!win) return

  const hôte = typeof document !== 'undefined' ? document : null
  let souhaité = ''
  try {
    souhaité = win.document?.title ?? ''
  } catch {
    // Frame inaccessible (cross-origin) : on imprime sans toucher au titre.
  }
  const précédent = hôte?.title

  try {
    if (hôte && souhaité) hôte.title = souhaité
    win.focus()
    win.print()
  } finally {
    if (hôte && précédent !== undefined) hôte.title = précédent
  }
}
